// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d6aaba10","455":"97f73bf8","977":"53a6baef"}[chunkId] + ".chunk.js";
};